import styled from 'styled-components';

import { getRem, truncateText, typographyGroupLabel, visuallyHidden } from './../../core';

const ContextMenuListGroupLabel = styled.span`
  ${({ theme }) => typographyGroupLabel(theme)}
  ${truncateText}
    box-sizing: border-box;
  display: block;
  font-weight: ${({ theme }) => theme.font.weight.bold.value};
  margin-bottom: ${({ theme }) => theme.size.spacing.small.value};
  margin-top: ${getRem('12px')};
  padding: 0 ${getRem('12px')};
  ${({ isVisuallyHidden }) => isVisuallyHidden && visuallyHidden}
`;

export { ContextMenuListGroupLabel };
